export default __webpack_public_path__ + "static/media/pantaloncillo-explorador-hombre.069b77f5.png";